export enum ResourceFormat {
  PDF = 'pdf',
  WEB = 'web',
  XLSX = 'xlsx',
  VIDEO = 'video',
  IMAGE = 'image',
}
